import { Modal } from 'react-bootstrap'

export const ShowImageInModal = ({ show, handleClose, image }: { show: boolean, handleClose: () => void, image: string }) => {
    return (
        <Modal show={show} onHide={handleClose} centered className='bg-black' >
            <Modal.Header closeButton>
            </Modal.Header>
            <Modal.Body>
                <img src={image} alt="imagen" className='rounded-3' style={{ width: '100%', height: '100%' }} />
            </Modal.Body>
        </Modal>
    )
}
